import useUpdateTeamRoleGq from './mutations/updateTeamRoleGq';
import useAcceptConnectionInvitationGq from './mutations/useAcceptConnectionInvitationGq';
import useCreateConnectionInvitationGq from './mutations/useCreateConnectionInvitationGq';
import useCreateStripeCheckoutSessionGq from './mutations/useCreateStripeCheckoutSessionGq';
import useCreateStripeCustomerPortalSessionGq from './mutations/useCreateStripeCustomerPortalSessionGq';
import useEditAllowedDomainsGq from './mutations/useEditAllowedDomainsGq';
import useEditProjectAccessGq from './mutations/useEditProjectAccessGq';
import useEditTeamOptionsGq from './mutations/useEditTeamOptionsGq';
import useInviteUserGq from './mutations/useInviteUserGq';
import useInviteUsersDuringRegistrationGq from './mutations/useInviteUsersDuringRegistrationGq';
import useRemoveConnectedTeamGq from './mutations/useRemoveConnectedTeamGq';
import useRemoveUserAccessGq from './mutations/useRemoveUserAccessGq';
import useRestoreUserAccessGq from './mutations/useRestoreUserAccessGq';
import useSendConnectionInvitationMailGq from './mutations/useSendConnectionInvitationMailGq';
import useUpdateSubscriptionLicensesGq from './mutations/useUpdateSubscriptionCapacityGq';
import useUpdateUserCurrencyGq from './mutations/useUpdateUserCurrencyGq';
import useUpdateUserLanguageGq from './mutations/useUpdateUserLanguageGq';
import useUpdateUserLocationGq from './mutations/useUpdateUserLocationGq';
import useUpdateUserPaletteGq from './mutations/useUpdateUserPaletteGq';
import useLogFrontendUserEventGq from './queries/useFrontendLogUserEventGq';
import { useGetAppTiersGq } from './queries/useGetAppTiersGq';
import { useGetConnectionInvitationGq } from './queries/useGetConnectionInvitationGq';
import { useGetCurrentUserGq } from './queries/useGetCurrentUserGq';
import { useGetProjectAccessTeamsGq } from './queries/useGetProjectAccessTeamsGq';
import { useGetSimplifiedTeamsGq } from './queries/useGetSimplifiedTeamsGq';
import { useGetStripeCheckoutGq } from './queries/useGetStripeCheckoutGq';
import { useGetTeamConnectionsGq } from './queries/useGetTeamConnectionsGq';
import { useGetTeamUsersGq } from './queries/useGetTeamUsersGq';
import { useGetUserExistGq } from './queries/useGetUserExistGq';

export const usersApiService = {
  queries: {
    useGetCurrentUser: useGetCurrentUserGq,
    useGetProjectAccessTeams: useGetProjectAccessTeamsGq,
    useGetTeamConnections: useGetTeamConnectionsGq,
    useGetSimplifiedTeams: useGetSimplifiedTeamsGq,
    useGetUserExist: useGetUserExistGq,
    useGetTeamUsers: useGetTeamUsersGq,
    useGetConnectionInvitation: useGetConnectionInvitationGq,
    useGetAppTiers: useGetAppTiersGq,
    useGetStripeCheckout: useGetStripeCheckoutGq,
  },
  mutations: {
    useInviteUser: useInviteUserGq,
    useInviteUsersDuringRegistration: useInviteUsersDuringRegistrationGq,
    useEditProjectAccess: useEditProjectAccessGq,
    useRemoveUserAcess: useRemoveUserAccessGq,
    useRemoveConnectedTeam: useRemoveConnectedTeamGq,
    useRestoreUserAccess: useRestoreUserAccessGq,
    useEditTeamOptions: useEditTeamOptionsGq,
    useEditAllowedDomains: useEditAllowedDomainsGq,
    useUpdateUserLanguage: useUpdateUserLanguageGq,
    useUpdateUserLocation: useUpdateUserLocationGq,
    useUpdateUserCurrency: useUpdateUserCurrencyGq,
    useUpdateUserPalette: useUpdateUserPaletteGq,
    useLogFrontendUserEvent: useLogFrontendUserEventGq,
    useCreateConnectionInvitation: useCreateConnectionInvitationGq,
    useSendConnectionInvitationMail: useSendConnectionInvitationMailGq,
    useAcceptConnectionInvitation: useAcceptConnectionInvitationGq,
    useCreateStripeCheckoutSession: useCreateStripeCheckoutSessionGq,
    createStripeCustomerPortalSession: useCreateStripeCustomerPortalSessionGq,
    useUpdateSubscriptionLicenses: useUpdateSubscriptionLicensesGq,
    useUpdateTeamRole: useUpdateTeamRoleGq,
  },
};
